//------------------
// get role details
//------------------
export default function getRoleDetails(role, objArray) {
  // console.log("----------------------")
  // console.log("IN getRoleDetails")
  let details = objArray.find((a) => a.name == role || a.label == role)
  return details
}
